var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"voucher-list"},[_c('mm-spinner',{attrs:{"visible":_vm.loading}}),_c('mm-table',{attrs:{"columns":_vm.columns,"data-source":_vm.voucherList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }